import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const AREAS = [
  { name: "Royal Crescent & Circus", img: "https://images.unsplash.com/photo-1679402894196-4f07f3e90b40?q=85&w=800", note: "Bath's most iconic Georgian addresses" },
  { name: "Pulteney & Bathwick", img: "https://images.unsplash.com/photo-1656328766855-2efa4153e6f2?q=85&w=800", note: "Riverside living by Pulteney Bridge" },
  { name: "Lansdown & Camden", img: "https://images.unsplash.com/photo-1767976755167-3abfb98fdeb9?q=85&w=800", note: "Elevated crescents with city views" },
  { name: "Widcombe & Central", img: "https://images.unsplash.com/photo-1676759527306-917ebf6fce55?q=85&w=800", note: "Village charm moments from the centre" },
];

const BathShowcase = () => (
  <section className="py-20 bg-white" data-testid="bath-showcase">
    <div className="max-w-[1280px] mx-auto px-5 md:px-8">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
        <div>
          <p className="text-[12px] tracking-[0.28em] uppercase text-[#b8935f] mb-3 flex items-center gap-2"><MapPin size={15} /> Proudly Bath</p>
          <h2 className="font-display text-[32px] md:text-[42px] font-300 text-[#1c1c1e] leading-tight">Homes across the city we know best</h2>
          <p className="text-[15px] text-[#6a6a6a] mt-3 max-w-2xl">From the sweep of the Royal Crescent to riverside apartments by Pulteney Bridge — Anadear Estates is Bath born and Bath focused, with unrivalled knowledge of every street and postcode.</p>
        </div>
        <Link to="/buying" className="inline-flex items-center gap-2 text-[14px] font-500 text-[#b8935f] hover:gap-3 transition-all whitespace-nowrap" data-testid="bath-showcase-cta">Browse Bath homes <ArrowRight size={16} /></Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {AREAS.map((a) => (
          <Link to="/buying" key={a.name} className="group relative rounded-2xl overflow-hidden aspect-[3/4]">
            <img src={a.img} alt={`Property in ${a.name}, Bath`} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-white font-display text-[18px] font-400 leading-tight">{a.name}</p>
              <p className="text-white/70 text-[12px] mt-1">{a.note}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default BathShowcase;
